import BatchWorker from './worker?worker';
import type { PongMessage, WorkerResponse } from './worker';

/**
 * Asks a worker what it can actually do.
 *
 * The batch engine depends on `OffscreenCanvas`, `Path2D` and `convertToBlob` being
 * available *inside a worker*, which is not the same thing as them existing on the main
 * thread. Checking once at start-up lets the UI fall back to single-threaded rendering
 * with an explanation, instead of silently producing nothing.
 */
export function probeWorker(timeoutMs = 4000): Promise<PongMessage['capabilities'] | null> {
  return new Promise((resolve) => {
    let worker: Worker;
    try {
      worker = new BatchWorker();
    } catch {
      resolve(null);
      return;
    }

    const finish = (value: PongMessage['capabilities'] | null): void => {
      clearTimeout(timer);
      worker.terminate();
      resolve(value);
    };

    const timer = setTimeout(() => finish(null), timeoutMs);
    worker.onmessage = (event: MessageEvent<WorkerResponse>) => {
      if (event.data.type === 'pong') finish(event.data.capabilities);
    };
    worker.onerror = () => finish(null);
    worker.postMessage({ type: 'ping' });
  });
}
